export const ru = {
    "wallet.auth.title": "Создать аккаунт электронного кошелька",
    "wallet.auth.register": "Зарегистрироваться",
    "wallet.auth.login": "Войти",
    "wallet.auth.already_have": "У вас есть счет?",

    "auth.register.title": "Регистрация",
    "auth.register.first_name": "Ваше имя",
    "auth.register.last_name": "Ваша фамилия",
    "auth.register.email": "Email",
    "auth.register.address": "Адрес",
    "auth.register.city": "Город",
    "auth.register.country": "Страна",
    "auth.register.zip_code": "Почтовый индекс",
    "auth.register.address_section": "Информация об адресе",
    "auth.register.continue_btn": "Продолжить",    
    "auth.register.enter_help": "Вход для зарегистрированных пользователей.",
    "auth.register.enter_code_help": "Введите код из сообщения",
    "auth.register.enter_code_descr": "Введите 4-значный код, который мы выслали по номеру",
    "auth.register.send_again_btn": "Отправить еще раз",
    "auth.register.set_pin.help": "Установите пин-код",
    "auth.register.set_pin.descr": "Придумайте 4-значный пин-код, который вы будете использовать при подтверждении транзакций",
    "auth.register.set_pin.continue": "Продолжить",        
    
    "wallet.auth.login.register_link": "Регистрация",
    "wallet.auth.login.login": "Вход в личный кабинет",
    "wallet.auth.login.sms_help": "Вы получите SMS-сообщение с кодом подтверждения для входа в личный кабинет. ",
    "wallet.auth.login.new_help": "Регистрация для новых пользователей. ",
    "wallet.auth.login.send_code": "Отправить код",
    "wallet.auth.login.enter_code": "Введите код из сообщения",
    "wallet.auth.login.enter_code_descr": "Введите 4-значный код, который мы выслали по номеру",
    "wallet.auth.login.enter_btn": "Войти",
    "wallet.auth.login.sms_repeat": "Отправить еще раз",    
    "wallet.auth.change_number": "Изменить номер", 

    "phone_input.phone": "Номер телефона",    
    "phone_input.phone.default_country.name": "Russia",
    "phone_input.phone.default_country.code": "+7",    
    "phone_input.phone.default_country.iso": "RU",        
    "phone_input.phone.default_country.flag": "https://cdn.kcak11.com/CountryFlags/countries/ru.svg",        
    "phone_input.phone.default_country.mask": "(###)###-##-##",        

    "menu.home": "Главная",    
    "menu.wallet": "Кошелек",
    "menu.payment": "Оплата",
    "menu.history": "История",
    "menu.settings": "Аккаунт",

    "header.welcome.greetings": "Добро пожаловать",
    "header.welcome.subtitle": "Хорошего дня",


    "notifications.title": "Уведомления",
    "notifications.close_btn": "Закрыть",

    "qr_payment.title": "Платите с помощью QR-code",
    "qr_payment.description": "Теперь вы можете переводить средства просто наведя камеру на QR-code",

    "qr_payment.not_avaliable.title": "Оплата QR-кодом временно недоступна,",
    "qr_payment.not_avaliable.subtitle": "приносим извинения за доставленные неудобства.",
    "qr_payment.your_qr": "Ваш QR-code",
    "qr_payment.scan_qr": "Сканировать",

    "payment.topup_btn": "Пополнить",
    "payment.exchange_btn": "Обмен",
    "payment.withdrawal_btn": "Вывести",
    "payment.topup.not_avaliable": "Вывод средств не доступен, пожалуйста, пройдите идентификацию.",
    "payment.withdrawal.not_avaliable": "Пополнение кошелька не доступно, пожалуйста, пройдите идентификацию.",
    "payment.send_btn": "Отправить",
    "payment.qr_file_upload": "Перетащите или выберите файл QR-code",
    "payment.qr_file_upload_extensions": "Допустимые форматы: png, jpg",

    "wallet_save.send_btn": "Отправить",

    "transactions.title": "Транзакции",
    "transactions.list.operation": "операция",
    "transactions.list.withdrawal": "вывод",
    "transactions.list.topup": "пополнение",
    "transactions.list.empty_descr": "Совершите первый платеж и в этом месте появится список Ваших транзакций.",

    "account.create_btn": "+ Добавить счет",
    "account.create_new_btn": "+ Добавить новый счет",

    "history.title": "История",
    "history.category.default": "default",

    "profile.title": "Данные об аккаунте",
    "profile.email": "E-mail:",
    "profile.phone": "Телефон",
    "profile.register_date": "Дата регистрации",
    "profile.logout": "Выйти из аккаунта",
    

    "profile.identification.title": "Уровень идентификации",
    "profile.identification.level.title": "Текущий уровень",
    "profile.identification.upgrade.status": "Статус повышения",    
    "profile.identification.upgrade_btn": "повысить",
    "profile.identification.refresh_status_btn": "обновить статус",    
    "profile.identification.retry_upgrade_btn": "повторить идентификацию",    

    "profile.qr.title": "Это ваш  QR-code",        
    "profile.qr.share": "Поделитесь кодом, чтобы получать оплату",        
    "profile.qr.download": "Скачать QR-code",        
    
    "select_currency.text": 'Выберите валюту',

    "policy.title": "Юридическая информация",


    "exchange.index.title": 'Обмен валют',
    "exchange.from": 'из',
    "exchange.to": 'в',
    "exchange.current_balance": 'На счету:',
    "exchange.submit_btn": 'обменять',
    "exchange.index.not_available": 'Функция обмена недоступна для вашего аккаунта',

    "wallet_topup.select_account": "Выберите счет",
    "wallet_topup.amount": "Сумма",
    "wallet_topup.top_up": "Пополнить",
    "wallet_topup.accept_the": "Я принимаю",
    "wallet_topup.terms_of_use": "Условия использования",
    "wallet_topup.success": "Успех",    
    "wallet_topup.error": "Пополнение счёта временно недоступно. Повторите попытку позже.",

    "wallet_withdrawal.select_account": "Выберите счет",
    "wallet_withdrawal.amount": "Сумма",
    "wallet_withdrawal.card": "Карта",
    "wallet_withdrawal.success_message": "Заявка на вывод средств успешно создана!",
    "wallet_withdrawal.withdrawal_btn": "Вывести",

    "pay_modal.enter_pin": "Введите пин-код",
    "pay_modal.enter_pin_description": "Для подтверждения перевода введите ваш пин-код",
    "pay_modal.waiting": "Ожидание",
    "pay_modal.waiting_description": "Не закрывайте страницу",
    "pay_modal.try_again": "Повторите попытку позже",
}
